import { ChatBubbleBottomCenterTextIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { DiscriminatedTaskUpdateCreatedEvent } from '@/services/api/generated/matterChangesService';

import {
  ActivityActions,
  ActivityBody,
  ActivityDescription,
  ActivityIcon,
  ActivityItem,
  ActivityLink,
} from '../activity-feed-v2';
import { getUserFromEvent } from '../activity-feed-v2/ActivityDiffList';
import { truncate } from '../activity-feed-v2/utils';

export interface TaskUpdateCreatedEventProps {
  event: DiscriminatedTaskUpdateCreatedEvent;
}

export const TaskUpdateCreatedEvent: React.FC<TaskUpdateCreatedEventProps> = ({
  event,
}) => {
  const { task_update } = event.payload;
  const user = getUserFromEvent(event);

  const icon = (
    <ActivityIcon
      icon={
        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-teal-100">
          <ChatBubbleBottomCenterTextIcon className="h-4 w-4 text-teal-600" />
        </div>
      }
    />
  );

  const body = (
    <ActivityBody>
      <ActivityDescription>
        {task_update.update && (
          <div className="text-sm text-gray-600 italic">
            &ldquo;{truncate(task_update.update, 150)}&rdquo;
          </div>
        )}
        {task_update.visibility && (
          <div className="text-xs text-gray-500">
            Visibility: {task_update.visibility}
          </div>
        )}
      </ActivityDescription>
    </ActivityBody>
  );

  const actions = task_update?.task_id && (
    <ActivityActions>
      <ActivityLink
        href={`/matters/${event.matter_id}/updates?task_id=${task_update.task_id}`}
      >
        View Task
      </ActivityLink>
    </ActivityActions>
  );

  return (
    <ActivityItem
      icon={icon}
      title="Task Comment"
      timestamp={new Date(event.occurred_at ?? new Date())}
      user={user}
      body={body}
      actions={actions}
    />
  );
};
